export const OBJECTIVES_TITLE = 'Objectives'
